import { CommonReservedTags } from '../types/tags';

const reservedTagValues = new Set<string>(
    Object.values(CommonReservedTags) as string[],
);

/**
 * Filters out internal/reserved tags (prefixed with `srt_`) from a tag array.
 * Returns only user-facing tags.
 */
export const getVisibleTags = (tags: string[] | undefined): string[] => {
    if (!tags) return [];
    return tags.filter((tag) => !reservedTagValues.has(tag));
};
